import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import type { ApiDropRater } from "@/generated/models/ApiDropRater";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import { WAVE_VOTING_LABELS } from "@/helpers/waves/waves.constants";
interface WaveWinnersDropHeaderVoterProps {
  readonly voter: ApiDropRater;
  readonly winner: ApiWaveDecisionWinner;
  readonly index: number;
}
export default function WaveWinnersDropHeaderVoter(t0) {
  const $ = _c(22);
  const {
    voter,
    winner,
    index
  } = t0;
  const voterLabel = voter.profile.handle ?? voter.profile.primary_address;
  const t1 = winner.drop.top_raters.length - index;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      zIndex: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `winner-voter-${voter.profile.id}`;
  const t4 = `/${voterLabel}`;
  let t5;
  if ($[2] !== voter.profile.pfp || $[3] !== voterLabel) {
    t5 = voter.profile.pfp ? <img src={getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${voterLabel}'s Profile`} className="tw-h-6 tw-w-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" /> : <div className="tw-h-6 tw-w-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />;
    $[2] = voter.profile.pfp;
    $[3] = voterLabel;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <Link href={t4}>{t5}</Link>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t6) {
    t7 = <div className="tw-relative tw-transition-transform hover:tw-z-10 hover:tw-scale-110" style={t2} data-tooltip-id={t3}>{t6}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `winner-voter-${voter.profile.id}`;
  let t9;
  if ($[12] !== voter.rating) {
    t9 = formatNumberWithCommas(voter.rating);
    $[12] = voter.rating;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = WAVE_VOTING_LABELS[winner.drop.wave.voting_credit_type];
  let t11;
  if ($[14] !== t10 || $[15] !== t8 || $[16] !== t9 || $[17] !== voterLabel) {
    t11 = <Tooltip id={t8} place="top" offset={8} opacity={1} positionStrategy="fixed" style={TOOLTIP_STYLES}>{voterLabel} • {t9}{" "}{t10}</Tooltip>;
    $[14] = t10;
    $[15] = t8;
    $[16] = t9;
    $[17] = voterLabel;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t7) {
    t12 = <>{t7}{t11}</>;
    $[19] = t11;
    $[20] = t7;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}